import { CarregaService } from '../services/carrega_file/carrega.service';
import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, ViewChild } from '@angular/core';
// import { format, parse, differenceInDays } from 'date-fns';
import { ApiService } from '../services/contratos/contratos.service';
import { map, take } from 'rxjs/operators';
// import { formatDate } from '@angular/common';
import { Observable } from 'rxjs';
// import * as XLSX from 'xlsx';
// import { utcParse } from 'd3';

@Component({
    selector: 'app-upload-excel-diretos',
    templateUrl: './upload-excel-diretos.component.html',
    styleUrls: ['./upload-excel-diretos.component.css'],
    standalone: false
})
export class UploadExcelDiretosComponent {

  progressValue = 0; // Valor atual da barra de progresso
  maxValue = 0; // Valor máximo da barra de progresso
  showProgressBar = false;
  @ViewChild('downloadLink') downloadLink!: ElementRef<HTMLAnchorElement>;
  urlAtualiza: string = 'https://uj88w4ga9i.execute-api.sa-east-1.amazonaws.com/dev12';
  urlConsulta: string = 'https://fopq9ohj7e.execute-api.sa-east-1.amazonaws.com/v1';
  query: string = 'items_Excel_Diretos';
  items$: Observable<any> | undefined;
  dataLoaded = false;
  jsonData: any;
  sortColumn: string = '';
  sortDirection: number = 1;
  dias_terminal: Date = new Date();
  Freetime: number = 0;
  dados: any[] = [];
  contratos: string[] = [];
  freetime: string[] = [];
  tripcost: string[] = [];
  custoViagem: string = "";
  handling: string[] = [];
  manuseio: string = "";
  demurrage: string[] = [];
  estadia: string = "";
  valorFree: string = '';
  liner: string = "";
  vessel: string = "";
  custoestadia: number = 0;
  isLoading: boolean = true;
  query3: string = 'tipos_Veiculos_Karrara';
  urlConsultaCompleta: string = 'https://fopq9ohj7e.execute-api.sa-east-1.amazonaws.com/v1';
  veiculos!: any[];


  constructor(
    private carregaService: CarregaService,
    private http: HttpClient,
    private dynamodbService: ApiService
  ) { }

  async onFileSelected(event: any) {
    const file: File = event.target.files[0];
    const fileUrl = URL.createObjectURL(file);
    const fileBlob = await fetch(fileUrl).then(response => response.blob());
    const rawData = await this.carregaService.loadFile(fileBlob);
    const inflatedData = await this.inflateData(rawData); // Inflar os campos desejados
    this.jsonData = inflatedData;
    this.dataLoaded = true;
    // console.log("jsonData")
    // console.log(this.jsonData)    
    // Chama a função para salvar os dados no API Gateway
  }

  async salvarNoBanco(jsonData: any) {
    // this.isLoading = true;
    this.showProgressBar = true;
    // console.log('Item a ser salvo:', jsonData);
    this.progressValue = 0;
    this.maxValue = jsonData.length;
    const batchSize = 10; // Defina o tamanho máximo para cada lote
    const batches = this.chunkArray(jsonData, batchSize); // Fraciona o jsonData em lotes menores

    for (const batch of batches) {
      // Acrescentar o campo "lastupdate" com o valor da data de hoje
      const currentDate = new Date().getTime();
      // console.log(currentDate)
      // Extrai os componentes de data e hora da data atual
      // const year = currentDate.getFullYear();
      // const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
      // const day = currentDate.getDate().toString().padStart(2, '0');
      // const hours = currentDate.getHours().toString().padStart(2, '0');
      // const minutes = currentDate.getMinutes().toString().padStart(2, '0');
      // const seconds = currentDate.getSeconds().toString().padStart(2, '0');
      // // Formata a data e hora no formato ISO desejado (sem considerar o fuso horário)
      // const isoDateString = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.000Z`;
      // console.log(isoDateString);
      for (const item of batch) {
        item.created = currentDate.toString();
      }
      await this.dynamodbService.salvar(batch, this.query, this.urlAtualiza).subscribe(
        response => {
          this.progressValue = this.progressValue + batch.length;
          // //console.log('Resposta do salvamento:', response);
          this.showProgressBar = false;
          this.isLoading = false;
        },
        error => {
          console.error('Erro ao salvar:', error);
        }
      );
    }
  }


  chunkArray(array: any[], size: number): any[][] {
    const chunks = [];
    for (let i = 0; i < array.length; i += size) {
      chunks.push(array.slice(i, i + size));
    }
    return chunks;
  }

  async ngOnInit() {
    // await this.getVeiculosFromDynamoDB();
    const key = 'liner'; // Substitua 'propriedade' pelo nome da propriedade que você deseja obter
    const query = 'PowerMathDatabase2'
    const filtro = '';
    this.items$ = (await this.dynamodbService.getItems(query, this.urlConsulta, filtro)).pipe(
      map(data => {
        const parsedData = JSON.parse(data.body); // Parse a string JSON contida em data.body
        return parsedData; // Retorna o objeto JSON parseado
      })
    );


    this.items$.subscribe(
      items => {
        this.contratos = items.map((item: { liner: any; }) => item.liner);
        this.freetime = items.map((item: { freetime: any; }) => item.freetime);
        this.tripcost = items.map((item: { tripcost: any; }) => item.tripcost);
        this.handling = items.map((item: { fsperiod: any; }) => item.fsperiod);
        this.demurrage = items.map((item: { scperiod: any; }) => item.scperiod);

      },
      error => {
        console.error(error);
      }
    );
    this.isLoading = false;
  }



  testarArquivo(arquivo: File): void {
    this.carregaService.testarArquivoCSV(arquivo).then((estaCorreto) => {
      if (estaCorreto) {
        //console.log('O arquivo CSV está correto.');
      } else {
        //console.log('O arquivo CSV está incorreto.');
      }
    }).catch((erro) => {
      console.error('Erro ao testar o arquivo CSV:', erro);
    });
  }

  //   converterNumeroSerieParaData(numeroSerie: number): Date {
  //     console.log("entrou converte data")
  //     console.log(numeroSerie)
  //     const dataBase = new Date("1899-12-30"); // Excel considera 30/12/1899 como a data base
  //     const data = new Date(dataBase.getTime() + (numeroSerie - 1) * 24 * 60 * 60 * 1000); // Converter número de série para milissegundos e adicionar à data base
  //     console.log(data)
  //     return data;
  // }

  converterNumeroSerieParaData(numeroSerie: number): Date {
    // Data de referência do Excel (31 de dezembro de 1899)
    const excelStartDate: Date = new Date('1899-12-31');
    // Calcula a data adicionando o número de dias ao início do calendário do Excel
    const convertedDate: Date = new Date(excelStartDate.getTime() + (numeroSerie * 24 * 60 * 60 * 1000));
    // Cria uma nova data apenas com o ano, mês e dia da data original
    const extractedDate: Date = new Date(convertedDate.getFullYear(), convertedDate.getMonth(), convertedDate.getDate());
    // console.log(extractedDate);
    // console.log(convertedDate);
    return extractedDate;
  }

  // Função para converter fração do dia em formato de hora
  converterHora(fraçãoDoDia: number, data: Date): Date {
    const horas: number = Math.floor(fraçãoDoDia * 24); // Extrai as horas
    const minutos: number = Math.round(((fraçãoDoDia * 24) % 1) * 60); // Extrai os minutos
    // Formata a hora e o minuto para que tenham sempre dois dígitos
    const horaFormatada: string = ('0' + horas).slice(-2);
    const minutosFormatados: string = ('0' + minutos).slice(-2);
    // Retorna a hora formatada
    const horaString = horaFormatada + ":" + minutosFormatados;
    // Divide a string da hora em horas e minutos
    const [hora, minuto] = horaString.split(':').map(Number);
    // Define as horas e minutos na data obtida anteriormente
    data.setHours(hora - 3, minuto, 0, 0);
    // console.log(data);
    return data
  }

  inflateData(rawData: any[]): any[] {
    return rawData.map((item: any) => {
      // console.log(item)
      // console.log(item[4])
      const dataFormatada: Date = this.converterNumeroSerieParaData(item[1]);
      // console.log(dataFormatada)
      const dataFaltaFormatada: Date = this.converterNumeroSerieParaData(item[14]);
      const horaFormatada: Date = this.converterHora(item[2], dataFormatada);
      // console.log(item[2]); // Saída: 01:00
      // console.log(horaFormatada); // Saída: 01:00
      // console.log(horaFormatada.toISOString()); // Saída: 01:00
      const inflatedItem: any = {
        'tableName': this.query,
        'ID': item[4],
        'idContainer': item[4],
        'transportador': item[0],
        'Janela': horaFormatada,
        'processo': item[3],
        'linner': item[5],
        'fatura': item[6],
        'destino': item[7],
        'num_NF1': item[8],
        'quantidadeMU': item[9],
        'terminalOrigem': item[10],
        'destinoApos': item[11],
        'terminalAtual': item[12],
        'itemCritico': item[13],
        'dataFalta': dataFaltaFormatada,
        'invoiceRemarks': item[15]
      };
      return inflatedItem;
    });
  }

  // async getVeiculosFromDynamoDB(): Promise<void> {
  //   try {
  //     const filtro = '';
  //     const response: any = await new Promise(async (resolve, reject) => {
  //       (await this.dynamodbService.getItems(this.query3, this.urlConsultaCompleta, filtro)).subscribe(
  //         (res: any) => resolve(res),
  //         (error: any) => reject(error)
  //       );
  //     });

  //     if (response.statusCode === 200) {
  //       try {
  //         const items = JSON.parse(response.body);
  //         if (Array.isArray(items)) {
  //           this.veiculos = items.map(item => ({ ...item, checked: false }));
  //           // this.cdr.detectChanges();
  //         } else {
  //           console.error('Invalid items data:', items);
  //         }
  //       } catch (error) {
  //         console.error('Error parsing JSON:', error);
  //       }
  //     } else {
  //       console.error('Invalid response:', response);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // }

  sortBy(column: string) {
    if (this.sortColumn === column) {
      // Reverse the sort direction
      this.sortDirection *= -1;
    } else {
      // Set the new sort column and reset the sort direction
      this.sortColumn = column;
      this.sortDirection = 1;
    }

    // Sort the data array based on the selected column and direction
    this.jsonData.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const valueA = a[this.sortColumn];
      const valueB = b[this.sortColumn];

      if (valueA < valueB) {
        return -1 * this.sortDirection;
      } else if (valueA > valueB) {
        return 1 * this.sortDirection;
      } else {
        return 0;
      }
    });
  }

}
